import './SlideThumbnail.scss';
import { useSlideSignedUrl } from './useSlideSignedUrl';

interface SlideThumbnailProps {
  slideNumber: number;
  imageUrl: string;
}

export const SlideThumbnail = ({ slideNumber, imageUrl }: SlideThumbnailProps) => {
  const { data: signedUrl, isLoading } = useSlideSignedUrl(imageUrl);

  if (isLoading) {
    return (
      <div className='slide-card-skeleton'>
        <div className='slide-image-skeleton' />
        <div className='slide-number-skeleton' />
      </div>
    );
  }

  return (
    <div className='slide-card'>
      <img
        src={signedUrl || imageUrl}
        alt={`Slide ${slideNumber}`}
        loading='lazy'
        decoding='async'
      />
      <div className='slide-number'>{slideNumber}</div>
    </div>
  );
};
